<template>
  <component
    :is="col.headerComponent"
    v-if="col.headerComponent"
    v-bind="col.props"
    v-model="colFilters[col.filter]"
    :col="col"
    :show-label="showLabel"
  />
  <re-select
    v-else-if="col.selectOptions"
    v-model="colFilters[col.filter]"
    :options="col.selectOptions"
    :multiple="col.isMultiSelect"
    size="sm"
    use-chips
    hide-bottom-space
    :label="showLabel ? col.label : undefined"
  />
  <re-input
    v-else-if="col.searchable"
    v-model.trim="colFilters[col.filter]"
    :rules="col.validation || []"
    show-error-as-tooltip
    empty-always-valid
    :debounce="600"
    size="sm"
    hide-bottom-space
    :label="showLabel ? col.label : undefined"
  >
    <template
      v-if="!colFilters[col.filter]?.length"
      #prepend
    >
      <re-icon
        name="mdi-magnify"
        size="xs"
      />
    </template>
  </re-input>
</template>

<script setup>
defineProps({
  col: {
    type: Object,
    required: true,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
})

const colFilters = defineModel({
  type: Object,
  required: true,
})
</script>

<style scoped lang="scss"></style>
